var map = {
	"./BeforeAfter.js": 5843,
	"./CodeBlock.js": 7527,
	"./CodeCard.js": 8997,
	"./Demo.js": 9055,
	"./Diagram.js": 4118,
	"./PromptMarquee.js": 8418,
	"./Starfield.js": 3880,
	"components/BeforeAfter.js": 5843,
	"components/CodeBlock.js": 7527,
	"components/CodeCard.js": 8997,
	"components/Demo.js": 9055,
	"components/Diagram.js": 4118,
	"components/PromptMarquee.js": 8418,
	"components/Starfield.js": 3880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8965;